import Img1 from "../../assets/project1.png";
import Img2 from "../../assets/project2.png";
import Img3 from "../../assets/project3.png";

const ProjectList = [
	{
		id: "1",
		title: "Portfolio",
		category: "react",
		technologies: "React",
		img: Img1,
		desc: "Technologies : React | HTML | CSS",
		link: "https://github.com/vinojini0322/portfolio-sample",
	},
	{
		id: "2",
		title: "Banking Application",
		category: "java",
		technologies: "Java",
		img: Img2,
		desc: "Technologies: Core Java",
		link: "https://github.com/vinojini0322/guess-the-word.git",
	},
	{
		id: "3",
		title: "Guess The word",
		category: "java",
		technologies: "Java",
		img: Img3,
		desc: "Technologies: Java",
		link: "",
	},
	// {
	// 	id: "4",
	// 	title: "Project 4",
	// 	category: "react",
	// 	technologies: "React",
	// 	img: Img1,
	// 	desc: "Technologies: Flutter | Java | PostgreSQL",
	// 	link: "",
	// },
	// {
	// 	id: "5",
	// 	title: "Project 1",
	// 	category: "react",
	// 	technologies: "React",
	// 	img: Img1,
	// 	desc: "Technologies: Flutter | Java | PostgreSQL",
	// 	link: "",
	// },
	// {
	// 	id: "6",
	// 	title: "Project 2",
	// 	category: "java",
	// 	technologies: "Java",
	// 	img: Img2,
	// 	desc: "Technologies: Flutter | Java | PostgreSQL",
	// 	link: "",
	// },
	// {
	// 	id: "7",
	// 	title: "Project 3",
	// 	category: "anguar",
	// 	technologies: "Angular",
	// 	img: Img3,
	// 	desc: "Technologies: Flutter | Java | PostgreSQL",
	// 	link: "",
	// },
	// {
	// 	id: "8",
	// 	title: "Project 4",
	// 	category: "react",
	// 	technologies: "React",
	// 	img: Img1,
	// 	desc: "Technologies: Flutter | Java | PostgreSQL",
	// 	link: "",
	// },
];
export default ProjectList;
